// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting-input-wrap {
    position: relative;
}

.setting-input-wrap input {
    padding-right: 2.6rem;
}

.setting-eye {
    position: absolute;
    right: 0.6rem;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: var(--color-ink-faint);
    display: flex;
    align-items: center;
    padding: 0.25rem;
    cursor: pointer;
    border-radius: 6px;
}

.setting-eye:hover {
    color: var(--color-ink);
}

.setting-eye:focus-visible {
    outline: 2px solid var(--bs-primary);
    outline-offset: 2px;
}

.setting-shield {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(47, 111, 235, 0.1);
    color: var(--bs-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/setting.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mCAAmC;IACnC,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB","sourcesContent":[".setting-input-wrap {\n    position: relative;\n}\n\n.setting-input-wrap input {\n    padding-right: 2.6rem;\n}\n\n.setting-eye {\n    position: absolute;\n    right: 0.6rem;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    color: var(--color-ink-faint);\n    display: flex;\n    align-items: center;\n    padding: 0.25rem;\n    cursor: pointer;\n    border-radius: 6px;\n}\n\n.setting-eye:hover {\n    color: var(--color-ink);\n}\n\n.setting-eye:focus-visible {\n    outline: 2px solid var(--bs-primary);\n    outline-offset: 2px;\n}\n\n.setting-shield {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    background: rgba(47, 111, 235, 0.1);\n    color: var(--bs-primary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
